var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app2"}},[_c('el-container',{staticClass:"container"},[_c('el-container',{staticClass:"main"},[_c('el-main',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }